// import { bootStrapHotelApp2 } from './HotelApplicationBoot';
// import { bootStrapHotelApp } from './HotelApplication';
import { bootStrapHotelApp } from './boot-app';
// import { readSample } from './sample'; 
// bootStrapHotelApp(window['firebaseConfiguration'] as any );

console.log("process, ", process.env);
export default function runBootStrap() {
   //  bootStrapHotelApp(); 
   fetch('/__/firebase/init.json').then(response => {
      response.json().then(confFirebase => {
         
         bootStrapHotelApp(confFirebase as any); 
      });
  
  });
   
}
runBootStrap() ; 


// WEBPACK FOOTER //
// ./src/index.tsx